import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { RequireAuth } from "@/components/RequireAuth";
import ClientLayout from "@/components/ClientLayout";
import AdminLayout from "@/components/AdminLayout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Shop from "@/pages/client/Shop";
import Cart from "@/pages/client/Cart";
import MyOrders from "@/pages/client/MyOrders";
import RequestPeptide from "@/pages/client/RequestPeptide";
import Dosing from "@/pages/client/Dosing";
import Refer from "@/pages/client/Refer";
import Dashboard from "@/pages/admin/Dashboard";
import Orders from "@/pages/admin/Orders";
import Clients from "@/pages/admin/Clients";
import ClientDetail from "@/pages/admin/ClientDetail";
import Inventory from "@/pages/admin/Inventory";
import Reconstitutions from "@/pages/admin/Reconstitutions";
import Requests from "@/pages/admin/Requests";
import Invites from "@/pages/admin/Invites";
import Promos from "@/pages/admin/Promos";
import Referrals from "@/pages/admin/Referrals";
import VendorOrders from "@/pages/admin/VendorOrders";
import AdminSettings from "@/pages/admin/Settings";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route element={<RequireAuth role="client"><ClientLayout /></RequireAuth>}>
              <Route path="/shop" element={<Shop />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/orders" element={<MyOrders />} />
              <Route path="/request" element={<RequestPeptide />} />
              <Route path="/calculator" element={<Dosing />} />
              <Route path="/dosing" element={<Navigate to="/calculator" replace />} />
              <Route path="/refer" element={<Refer />} />
            </Route>
            <Route path="/admin" element={<RequireAuth role="admin"><AdminLayout /></RequireAuth>}>
              <Route index element={<Dashboard />} />
              <Route path="orders" element={<Orders />} />
              <Route path="clients" element={<Clients />} />
              <Route path="clients/:id" element={<ClientDetail />} />
              <Route path="inventory" element={<Inventory />} />
              <Route path="reconstitution" element={<Reconstitutions />} />
              <Route path="requests" element={<Requests />} />
              <Route path="invites" element={<Invites />} />
              <Route path="promos" element={<Promos />} />
              <Route path="referrals" element={<Referrals />} />
              <Route path="vendor-orders" element={<VendorOrders />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" richColors />
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
